export default (axios) => axios.get('timezones');
